import {
  ChangeDetectionStrategy, Component, ElementRef, HostListener, Input,
  OnChanges, SecurityContext, ViewEncapsulation, inject
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-chat-markdown',
  standalone: true,
  template: '',
  styleUrl: './chat-markdown.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatMarkdownComponent implements OnChanges {
  @Input() html: string | null | undefined;

  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly sanitizer = inject(DomSanitizer);

  ngOnChanges(): void {
    const host = this.element.nativeElement;
    host.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.html ?? '') ?? '';

    for (const table of host.querySelectorAll('table')) {
      const wrapper = host.ownerDocument.createElement('div');
      wrapper.className = 'chat-markdown-scroll chat-markdown-table';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Table');
      table.replaceWith(wrapper);
      wrapper.appendChild(table);
    }
  }

  @HostListener('wheel', ['$event'])
  @HostListener('touchmove', ['$event'])
  allowHorizontalScroll(event: Event): void {
    const target = (event.target as HTMLElement).closest<HTMLElement>('.chat-markdown-scroll, pre');
    if (target && target.scrollWidth > target.clientWidth) {
      event.stopPropagation();
    }
  }
}
